import { Check } from 'lucide-react';
import { msg } from '@lingui/core/macro';
import { useLingui } from '@lingui/react/macro';
import { cn } from '@/lib/utils';
import type { MessageDescriptor } from '@lingui/core';

interface Step {
  label: MessageDescriptor;
  title: MessageDescriptor;
}

interface Props {
  currentStep: number; // 1-indexed
  onGoTo: (step: number) => void;
}

const STEPS: Step[] = [
  { label: msg`Step 01`, title: msg`Select items`    },
  { label: msg`Step 02`, title: msg`Customer info`   },
  { label: msg`Step 03`, title: msg`Assign & submit` },
];

export function NewOrderStepper({ currentStep, onGoTo }: Props) {
  const { i18n } = useLingui();

  return (
    <div className="grid grid-cols-3 gap-3">
      {STEPS.map((step, i) => {
        const n = i + 1;
        const isActive = n === currentStep;
        const isDone   = n < currentStep;

        return (
          <button
            key={n}
            type="button"
            onClick={() => onGoTo(n)}
            className={cn(
              'flex items-center gap-3.5 px-4 py-3.5 border rounded-[0.875rem] text-left transition-all',
              isActive
                ? 'bg-(--color-text-primary) border-(--color-text-primary) text-(--color-surface-page)'
                : 'bg-(--color-surface-content) border-(--color-border) hover:bg-(--color-surface-muted)',
            )}
          >
            {/* Number / check bubble */}
            <div
              className={cn(
                'w-8 h-8 rounded-full flex items-center justify-center shrink-0 text-[0.875rem] font-extrabold',
                isActive && 'bg-(--color-surface-page) text-(--color-text-primary)',
                isDone   && 'bg-(--color-success) text-(--brand-white)',
                !isActive && !isDone && 'bg-(--color-surface-muted) text-(--color-text-secondary)',
              )}
            >
              {isDone ? <Check className="w-4 h-4" /> : n}
            </div>

            <div>
              <div
                className={cn(
                  'text-[0.6875rem] uppercase tracking-widest font-bold',
                  isActive ? 'text-(--color-surface-page)/60' : 'text-(--color-text-secondary)',
                )}
              >
                {i18n._(step.label)}
              </div>
              <div
                className={cn(
                  'text-[0.9375rem] font-bold mt-px',
                  isActive ? 'text-(--color-surface-page)' : 'text-(--color-text-primary)',
                )}
              >
                {i18n._(step.title)}
              </div>
            </div>
          </button>
        );
      })}
    </div>
  );
}
